import { FileText, Clock, ListChecks, CheckCircle2, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  TRIAL_DISCLAIMER_LINE,
  TRIAL_EXAM_TITLE,
  TRIAL_QUESTIONS_LINE,
  TRIAL_SCORING_LINE,
  TRIAL_TIME_LINE,
} from "@/lib/trialExamConfig";

/**
 * Shared confirmation content for the free sample exam.
 *
 * Used both inline (replacing the locked page card) and inside a dialog,
 * so only one overlay is ever visible at a time.
 */
export const SampleExamConfirmBody = ({
  onCancel,
  onStart,
}: {
  onCancel: () => void;
  onStart: () => void;
}) => (
  <div className="space-y-5 text-center">
    <div className="flex justify-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary">
        <FileText className="h-7 w-7" />
      </div>
    </div>

    <div className="space-y-1">
      <h2 className="text-xl font-semibold text-foreground">{TRIAL_EXAM_TITLE}</h2>
      <p className="text-sm text-muted-foreground">
        A short taste of the real thing, free and optional.
      </p>
    </div>

    <ul className="mx-auto max-w-md space-y-3 text-left">
      <li className="flex items-start gap-3 text-sm text-foreground">
        <ListChecks className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
        <span>{TRIAL_QUESTIONS_LINE}</span>
      </li>
      <li className="flex items-start gap-3 text-sm text-foreground">
        <Clock className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
        <span>{TRIAL_TIME_LINE}</span>
      </li>
      <li className="flex items-start gap-3 text-sm text-foreground">
        <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
        <span>{TRIAL_SCORING_LINE}</span>
      </li>
    </ul>

    <div className="mx-auto flex max-w-md items-start gap-3 rounded-md border border-border bg-muted px-3 py-2.5 text-left">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" />
      <span className="text-sm text-muted-foreground">{TRIAL_DISCLAIMER_LINE}</span>
    </div>

    <div className="flex flex-wrap justify-center gap-2 pt-1">
      <Button variant="outline" onClick={onCancel}>
        Cancel
      </Button>
      <Button onClick={onStart}>Start</Button>
    </div>
  </div>
);

export default SampleExamConfirmBody;
